export const jobListings = [
    {
        id: 1,
        title: "Full-Stack Developer (React/Node)",
        location: "Remote, Global",
        type: "Full time",
        categories: ["technical"],
        description: "Develop end-to-end web applications using modern tech stack.",
        pay: "₹8-15 LPA + ESOPs",
        roles: [
            "Develop and maintain core product features using React.js and Node.js",
            "Collaborate with UX team to implement responsive designs",
            "Build RESTful APIs and integrate third-party services",
            "Write clean, maintainable code with unit tests",
            "Optimize applications for maximum speed and scalability",
            "Participate in code reviews and architectural decisions"
        ]
    },
    {
        id: 2,
        title: "DevOps Engineer",
        location: "Remote, Global",
        type: "Full time",
        categories: ["technical"],
        description: "Implement and maintain CI/CD pipelines and cloud infrastructure.",
        pay: "₹10-18 LPA + Bonus",
        roles: [
            "Design and manage AWS/GCP cloud infrastructure",
            "Implement automated deployment pipelines using Jenkins/GitHub Actions",
            "Monitor system performance and troubleshoot issues",
            "Maintain Kubernetes clusters and Docker environments",
            "Implement security best practices across infrastructure",
            "Collaborate with dev teams on environment configurations"
        ]
    },
    {
        id: 3,
        title: "Frontend Engineer (React)",
        location: "Remote, Global",
        type: "Full time",
        categories: ["technical"],
        description: "Build responsive UIs and maintain design systems.",
        pay: "₹6-12 LPA + Benefits",
        roles: [
            "Implement pixel-perfect responsive web interfaces",
            "Develop reusable React components and hooks",
            "Optimize frontend performance using Lighthouse metrics",
            "Collaborate with designers on design system implementation",
            "Integrate with backend APIs and handle state management",
            "Write comprehensive unit tests using Jest/React Testing Library"
        ]
    },
    {
        id: 4,
        title: "QA Automation Engineer",
        location: "Remote, Global",
        type: "Contract",
        categories: ["technical"],
        description: "Design and implement test automation frameworks.",
        pay: "₹6-10 LPA (Contract)",
        roles: [
            "Develop automated test scripts using Cypress/Selenium",
            "Create and maintain test plans and cases",
            "Perform load testing using JMeter/Locust",
            "Identify and document software defects",
            "Collaborate with developers on bug resolution",
            "Implement CI/CD integration for automated testing"
        ]
    },
    {
        id: 5,
        title: "Digital Marketing Specialist",
        location: "Remote, Global",
        type: "Full time",
        categories: ["growth"],
        description: "Manage SEO/SEM campaigns and social media strategies.",
        pay: "₹5-9 LPA + Performance Bonus",
        roles: [
            "Plan and execute digital marketing campaigns",
            "Optimize Google Ads and social media advertising",
            "Analyze campaign performance using Google Analytics",
            "Collaborate with content team on SEO strategy",
            "Manage marketing budget and ROI tracking",
            "Stay updated with latest digital marketing trends"
        ]
    },
    {
        id: 6,
        title: "Content Marketing Strategist",
        location: "Remote, Global",
        type: "Full time",
        categories: ["growth"],
        description: "Develop content calendar and brand voice guidelines.",
        pay: "₹4.5-8 LPA + Benefits",
        roles: [
            "Create and manage content calendar across channels",
            "Develop blog posts, whitepapers, and case studies",
            "Optimize content for SEO and user engagement",
            "Collaborate with design team on visual content",
            "Analyze content performance metrics",
            "Maintain consistent brand voice across all content"
        ]
    },
    {
        id: 7,
        title: "SEO/SEM Analyst",
        location: "Remote, Global",
        type: "Part time",
        categories: ["growth"],
        description: "Optimize organic search performance and manage PPC campaigns.",
        pay: "₹3-5 LPA (Pro Rata)",
        roles: [
            "Conduct keyword research and competitor analysis",
            "Optimize website content and metadata",
            "Manage Google Ads campaigns and budget",
            "Track rankings and prepare SEO reports",
            "Implement technical SEO improvements",
            "Collaborate with developers on SEO-friendly features"
        ]
    },
    {
        id: 8,
        title: "Technical Project Manager",
        location: "Remote, Global",
        type: "Full time",
        categories: ["operations"],
        description: "Lead agile development teams and manage project timelines.",
        pay: "₹12-20 LPA + Bonus",
        roles: [
            "Manage project scope, timeline, and resources",
            "Facilitate daily standups and sprint planning",
            "Coordinate between cross-functional teams",
            "Track project metrics and report to stakeholders",
            "Identify and mitigate project risks",
            "Implement Agile/Scrum best practices"
        ]
    },
    {
        id: 9,
        title: "HR & Culture Coordinator",
        location: "Remote, Global",
        type: "Full time",
        categories: ["operations"],
        description: "Manage recruitment and employee engagement programs.",
        pay: "₹4-7 LPA + Benefits",
        roles: [
            "Manage end-to-end recruitment process",
            "Coordinate employee onboarding and training",
            "Organize team-building activities and events",
            "Maintain employee records and HR policies",
            "Handle employee engagement initiatives",
            "Assist in performance review processes"
        ]
    },
    {
        id: 10,
        title: "Customer Success Engineer",
        location: "Remote, Global",
        type: "Full time",
        categories: ["customer"],
        description: "Provide technical support and onboarding for enterprise clients.",
        pay: "₹5-8 LPA + Incentives",
        roles: [
            "Onboard new clients and conduct product training",
            "Troubleshoot technical issues and provide solutions",
            "Collaborate with engineering team on bug resolution",
            "Maintain customer documentation and FAQs",
            "Gather customer feedback for product improvements",
            "Monitor customer health metrics and renewals"
        ]
    },
    {
        id: 11,
        title: "Technical Support Specialist",
        location: "Remote, Global",
        type: "Full time",
        categories: ["customer"],
        description: "Resolve customer technical issues and maintain documentation.",
        pay: "₹3-5 LPA + Training",
        roles: [
            "Respond to customer queries via email/chat",
            "Diagnose and troubleshoot technical issues",
            "Escalate complex issues to engineering team",
            "Maintain knowledge base articles",
            "Provide product usage guidance to clients",
            "Monitor and report recurring technical issues"
        ]
    }
];
